import styled, { css } from 'styled-components';
interface IButton {
  label: string;
}

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding: ${theme.spacings[12]};
    overflow-y: auto;

    .text-input-wrapper {
      margin-top: ${theme.spacings[2]};
      margin-bottom: ${theme.spacings[10]};
    }

    .notFound {
      text-align: center;
    }

    @media (max-width: 400px) {
      padding: ${theme.spacings[6]};
    }

    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.colors.gray50};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.blue700};
    }
  `}
`;

export const Separator = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 1px;
    background: ${theme.colors.blue100};
    margin: 8px 0;
  `}
`;

export const ExternalLayersHeader = styled.div`
  padding: 8px 12px;
  margin-top: 6px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  color: ${({ theme }) => theme.colors.blue100} || '#8a8a8a'};

  display: flex;
  align-items: center;
`;

export const EmptyExternalLayers = styled.div`
  font-size: 14px;
  color: #8c8c8c;
  padding: 8px 12px;
`;

export const ExternalLayerItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  border-radius: 6px;
  transition: background 0.2s ease;
  
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

export const ExternalLayerName = styled.span`
  font-size: 17px;
  font-weight: 500;
  color: #2b2b2b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
  a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  @media (max-width: 1600px) {
    width: 340px;
  }

  @media (max-width: 1000px) {
    width: 320px;
  }

  @media (max-width: 800px) {
    width: 278px;
  }

  @media (max-width: 600px) {
    width: 420px;
  }

  @media (max-width: 400px) {
    width: 240px;
  }
`;

export const ExternalLayerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  svg {
    color: #a1a1a1;
    transition: 0.2s;

    &:hover {
      color: #ff4d4f;
    }
  }
`;

export const Button = styled.button<IButton>`
  ${({ theme, label }) => css`
    position: relative;

    display: inline-flex;
    justify-content: center;

    border: 0;
    background-color: transparent;

    & + button {
      margin-left: ${theme.spacings[12]};
    }

    &:hover {
      &::before {
        top: ${label.includes(':') ? '-5rem' : '-3.5rem'};
        opacity: 1;
      }
    }

    &::before {
      content: '${label}';
      padding: ${theme.spacings[6]};
      position: absolute;
      top: -5rem;
      pointer-events: none;
      margin-right: ${label === 'Download' ? '30px' : '0px'};

      font-family: ${theme.font.family.default};
      font-size: ${theme.font.sizes.xs};
      font-weight: ${theme.font.weights.bold};

      border: 1px solid ${theme.colors.white};
      border-radius: 0.4rem;

      background-color: ${theme.colors.black};
      color: ${theme.colors.white};

      opacity: 0;
      transition: all 0.2s;
    }
  `}
`;

export const Content = styled.div`
  ${({ }) => css`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-left: 3%;
    margin-right: 3%;

    .layer {
      display: inline-flex;
      -moz-box-align: center;
      align-items: center;
    }

    @media (max-width: 400px) {
      display: flex;
      flex-direction: column;
    }
  `}
`;